// extracted by mini-css-extract-plugin
export default {"container":"error_container__S8F0c"};